import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import Loader from "components/Loader";
import CustomInput from "components/CustomInput/CustomInput";
import CustomModal from "components/CustomModal/CustomModal";
import TeamService from "services/TeamService";
import Button from "components/CustomButton";
import { useGlobalContext } from "store/contexts/globalContext";

export default ({ createMSTeam = null, selectTeam = null }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { createTeam } = useGlobalContext();

  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .matches(
          /^[a-zA-Z0-9\s]+$/,
          "Team name cannot contain any special characters."
        )
        .min(4, "Team name must be between 4 to 50 characters.")
        .max(50, "Team name must be between 4 to 50 characters.")
        .required(),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const response = await TeamService.createTeam(values.name);

        if (createMSTeam) {
          createMSTeam(response.data.data);
        }

        formik.setFieldValue("name", "");

        setIsOpen(false);
        setLoading(false);

        return !selectTeam
          ? create(response.data.data)
          : selectTeam(response.data.data);
      } catch (error) {
        if (error.response) {
          setErrorState(error.response.data.message);
        }
      }
      setLoading(false);
    },
  });

  const create = (team) => {
    history.push(`/teams/${team?.id}`);
    createTeam(team);
  };

  const setErrorState = (message) => {
    setErrorMessage(message);
    setTimeout((_) => {
      setErrorMessage("");
    }, 2000);
  };

  return (
    <>
      <Button
        type="button"
        onClick={() => setIsOpen(true)}
        buttonClass="light-gray-btn d-inline-block mb-3"
        name="Create Team"
      />
      <CustomModal
        show={isOpen}
        onClose={() => setIsOpen(false)}
        modalClass="modal-dialog"
      >
        <div className="modal fade popup-modal">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <h5>Create a Team</h5>
                <small className="fs-12 color-light">
                  The Team makes itself better. We are here to help.
                </small>
                <form noValidate onSubmit={formik.handleSubmit}>
                  <CustomInput
                    id={"name"}
                    inputProps={{
                      type: "text",
                      placeholder: "Enter Team Name Here",
                      ...formik.getFieldProps("name"),
                      error: formik.errors.name,
                    }}
                    inputClass="full_w"
                  />
                  {errorMessage && (
                    <div className="errorMessage">{errorMessage}</div>
                  )}
                  <Button
                    type="button"
                    buttonClass=" light-gray-btn me-2"
                    name="Cancel"
                    onClick={() => setIsOpen(false)}
                  />
                  <Button
                    name={
                      !loading ? (
                        "Create Team"
                      ) : (
                        <Loader width={25} height={25} />
                      )
                    }
                    buttonClass=" light-gray-btn"
                    disabled={loading && true}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};
